import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { players } from 'redux/modules'
import Loader from './Loader'

const PlayerLoader = ({
  playerId,
  fetchTeamPlayer,
  children,
  ...restProps
}) => {
  const fetchMethod = params => fetchTeamPlayer(playerId, params)
  const triggers = [playerId]

  return (
    <Loader fetchMethod={fetchMethod} triggers={triggers} {...restProps}>
      {children}
    </Loader>
  )
}

PlayerLoader.propTypes = {
  children: PropTypes.node.isRequired,
  playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchTeamPlayer: PropTypes.func.isRequired,
}
  
export default connect(
  null,
  { fetchTeamPlayer: players.fetchTeamPlayer }
)(PlayerLoader)
